<template>
    <div class="app-left-content-header">
        <h1 class="content-title">Reporte de Facturación</h1>
        <button class="logout-button" @click="authStore.logout(router)">Cerrar Sesión</button>
        <button class="logout-button-mobile" @click="authStore.logout(router)"><i class="pi pi-sign-out"></i></button>
    </div>
    <div class="app-content-field">
        <div class="container">
            <button class="toggle-filter-button" @click="toggleFilter">
                <span v-if="showFilter"><i class="pi pi-filter"></i></span>
                <span v-else><i class="pi pi-filter-slash"></i></span>
            </button>
            <Transition name="fade">
                <FilterComponent v-if="showFilter" @applyFilters="applyFilters" @downloadCSV="downloadCSV" />
            </Transition>
            <CardsResumeFact ref="cardsResumeRef" :fecha_inicio="fechaInicio" :fecha_fin="fechaFin" />
            <TableFact ref="tableFactRef" :fecha_inicio="fechaInicio" :fecha_fin="fechaFin" />
            <TableRent ref="tableRentRef" :fecha_inicio="fechaInicio" :fecha_fin="fechaFin" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';
import FilterComponent from '@/components/FilterComponent.vue';
import CardsResumeFact from '@/components/CardsResumeFact.vue';
import TableFact from '@/components/TableTravel.vue';
import TableRent from '@/components/TableRent.vue';
import Swal from 'sweetalert2';

// Stores y rutas
const authStore = useAuthStore();
const router = useRouter();
const showFilter = ref(true);

// Variables de fechas
const fechaInicio = ref(new Date().toISOString().split('T')[0]);
const fechaFin = ref(new Date().toISOString().split('T')[0]);

// Referencias a las tablas y resumen
const cardsResumeRef = ref(null);
const tableFactRef = ref(null);
const tableRentRef = ref(null);

const toggleFilter = () => {
    showFilter.value = !showFilter.value;
};

const applyFilters = (filters) => {
    if (!filters || !filters.fechaInicio || !filters.fechaFin || filters.fechaFin < filters.fechaInicio) {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Las fechas ingresadas no son válidas.',
            confirmButtonColor: '#3085d6',
            backdrop: false,
            scrollbarPadding: false
        });
        return;
    }

    if (filters.fechaInicio > filters.fechaFin) {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'La fecha de inicio debe ser menor que la fecha de fin.',
            confirmButtonColor: '#3085d6',
            backdrop: false,
            scrollbarPadding: false
        });
        return;
    }

    fechaInicio.value = filters.fechaInicio;
    fechaFin.value = filters.fechaFin;
};

const downloadCSV = async () => {
    try {
        const resumen = JSON.parse(JSON.stringify(cardsResumeRef.value?.getData() || []));
        const tableFactData = tableFactRef.value?.getData() || [];
        const tableRentData = tableRentRef.value?.getData() || [];

        if (resumen.length === 0 && tableFactData.length === 0 && tableRentData.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin datos',
                text: 'No hay información para exportar.',
                confirmButtonColor: '#3085d6',
                backdrop: false,
                scrollbarPadding: false
            });
            return;
        }

        const csvContent = generateCSV(resumen, tableFactData, tableRentData);
        downloadFile(csvContent, `Reporte_${fechaInicio.value}_a_${fechaFin.value}.csv`);

        Swal.fire({
            icon: 'success',
            title: 'Exportado',
            text: 'El archivo CSV se ha descargado.',
            confirmButtonColor: '#3085d6',
            backdrop: false,
            scrollbarPadding: false
        });
    } catch (error) {
        console.error("Error al descargar CSV:", error);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un problema al exportar los datos.',
            confirmButtonColor: '#3085d6',
            backdrop: false,
            scrollbarPadding: false
        });
    }
};

const generateCSV = (resumen, factData, rentData) => {
    let csv = 'Reporte de Facturacion\n\n';

    if (resumen.length) {
        csv += 'Resumen:\n';
        csv += Object.keys(resumen[0]).join(',') + '\n';
        csv += resumen.map(row => Object.values(row).join(',')).join('\n') + '\n\n';
    }

    if (factData.length) {
        csv += 'Tabla de Viajes:\n';
        csv += Object.keys(factData[0]).join(',') + '\n';
        csv += factData.map(row => Object.values(row).join(',')).join('\n') + '\n\n';
    }

    if (rentData.length) {
        csv += 'Tabla de Rentas:\n';
        csv += Object.keys(rentData[0]).join(',') + '\n';
        csv += rentData.map(row => Object.values(row).join(',')).join('\n') + '\n\n';
    }

    return csv;
};

const downloadFile = (content, fileName) => {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
</script>


<style scoped src="../styles/homePage.css"></style>
